import React from "react";
import { useTranslation } from 'react-i18next';
import "./about.css";
import Image from "../../assets/about-profile.png";
import AboutBox from "./AboutBox";
import cvFile from "../../assets/CV-Bram-Platier.pdf";

const About = () => {
    const { t } = useTranslation();

    return (
        <section className="about container section" id="about">
          <h2 className="section__title">{t('about_me')}</h2>
      
          <div className="about__container grid">
            <img src={Image} alt="" className="about__img" />
      
            <div className="about__data grid">
              <div className="about__info">
                <p className="about__description">
                  {t('about_description')}
                </p>
                <div className="about__actions">
                  <a href={cvFile} download="CV-Bram-Platier.pdf" className="btn" data-track="Download CV (About)">{t('download_cv')}</a>
                </div>
              </div>
            </div>
          </div>

          <AboutBox />
        </section>
      );
}

export default About;